<div class="d-flex flex-column gap-2">
	<h4>Status Log</h4>
	<div class="d-flex flex-column">
		@for (log of volunteerStatusLogs(); track log.volunteerStatusLogId) {
		<div class="d-flex align-items-center border border-light-subtle">
			<div class="icon-class d-flex align-items-center justify-content-center px-4">
				<i [class]="log.icon"></i>
			</div>
			<div class="border-start border-light-subtle flex-1 p-2">
				<div>
					{{log.status}} Application on {{log.updatedUTC }}
				</div>
				<div>
					By: {{log.displayName}}
				</div>
				@if(log.notes) {
				<div>
					Notes: {{log.notes}}
				</div>
				}
			</div>
		</div>
		} @empty {
		<div class="text-center p-2">
			<p>No status logs available for this application.</p>
		</div>
		}
	</div>
</div>